import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useGetProgressQuery, ProgressResponse } from 'store/progress'; // progressAPIが定義されたファイルからProgressResponseをインポート

/**
 * APIからゲームの進行状況を取得します
 * @returns {boolean} GETリクエストの成功・失敗を表すブール値
 */
export const useGetProgressData = (): {
  data: ProgressResponse | undefined;
  isSuccess: boolean;
  isLoading: boolean;
} => {
  const dispatch = useDispatch();

  // ユーザIDをRedux Storeから取得

  // useGetProgressQueryフックを使用してAPIからゲームの進行状況を取得します
  const { data, error, isSuccess, isLoading, isFetching, refetch } = useGetProgressQuery();

  useEffect(() => {
    if (isFetching) {
      refetch();
    }
  }, [isFetching, refetch]);

  // データの取得結果に応じて処理を行います
  useEffect(() => {
    if (isSuccess && data) {
      // console.log('useGetProgressData: success');
    } else if (error) {
      console.log('useGetProgressData: error', error);
    }
  }, [data, dispatch, error, isSuccess]);

  return { data, isSuccess, isLoading };
};
